import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select
} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import AddIcon from '@mui/icons-material/Add';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import EditIcon from '@mui/icons-material/Edit';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './styles';

export default function HeaderReport({
  enableSelect,
  reportId,
  handleChangeSelect,
  reportsData,
  enableNewButton,
  handleNewReport,
  enableButtons,
  handleEditReport,
  handleRunReport,
  indicatorsLoaded
}) {
  const classes = useStyles();
  return (
    <Paper elevation={0}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="flex-end"
      >
        <Grid item>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="flex-end"
          >
            <Grid item>
              <FormControl
                className={classes.formControl}
                disabled={enableSelect}
              >
                <Select
                  value={reportId}
                  onChange={handleChangeSelect}
                  style={{ fontSize: 14 }}
                >
                  {reportsData.map(report => (
                    <MenuItem value={report.id} key={report.id} style={{ fontSize: 14 }}>
                      {report.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                className={classes.button}
                disabled={!indicatorsLoaded || enableNewButton}
                onClick={handleNewReport}
                startIcon={<AddIcon />}
              >
                New
              </Button>
              <Button
                className={classes.button}
                disabled={!indicatorsLoaded || enableButtons}
                onClick={handleEditReport}
                startIcon={<EditIcon />}
              >
                Edit
              </Button>
                <Button
                disabled={enableButtons}
                className={classes.button}
                onClick={handleRunReport}
                startIcon={<DirectionsRunIcon />}
              >
                Generate Report
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      { !indicatorsLoaded && (<LinearProgress variant="query"/>)}
    </Paper>
  );
}

HeaderReport.propTypes = {
  enableSelect: PropTypes.bool,
  reportId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  handleChangeSelect: PropTypes.func,
  reportsData: PropTypes.array,
  enableNewButton: PropTypes.bool,
  handleNewReport: PropTypes.func,
  enableButtons: PropTypes.bool,
  handleEditReport: PropTypes.func,
  handleRunReport: PropTypes.func,
  indicatorsLoaded: PropTypes.bool
};
